import { defineStore } from 'pinia'
import { markRaw } from 'vue'

import { useInstanceStore } from 'src/stores/instance.js'
import { useInstanceCapabilitiesStore } from 'src/stores/instance_capabilities.js'
import { useUsersStore } from 'src/stores/users.js'

import { streamingUrl } from 'src/api/api_base.js'

// Maybe rename it to PhoenixSocket if we ever utilize this socket more
export const useShoutStore = defineStore('shout', {
  state: () => ({
    messages: [],
    channel: null,
    joined: false,
    socket: null,
  }),
  getters: {
    token: () => useUsersStore().currentUser?.token,
  },
  actions: {
    // the socket library loads only for instances with a shoutbox
    async initializeSocket() {
      if (this.token === null) return
      if (!useInstanceCapabilitiesStore().shoutAvailable) return
      // the instance's socket refuses other sites (Pleroma's origin check)
      if (useInstanceStore().hosted) return
      if (this.socket !== null) return

      const token = this.token
      const { Socket } = await import('phoenix')
      // logged out, or connected by another call, while it loaded
      if (!token || this.token !== token || this.socket !== null) return

      this.socket = markRaw(
        new Socket(streamingUrl('/socket'), { params: { token } }),
      )
      this.socket.connect()
    },
    // the socket and the public channel; both the login and a late
    // nodeinfo call this, so it joins once
    async initializeShout() {
      await this.initializeSocket()
      if (this.socket === null || this.channel !== null) return

      const channel = markRaw(this.socket.channel('chat:public'))

      channel.joinPush.receive('ok', () => {
        this.joined = true
      })
      channel.onClose(() => {
        this.joined = false
      })
      channel.onError(() => {
        this.joined = false
      })
      channel.on('new_msg', (msg) => {
        this.messages.push(msg)
        this.messages = this.messages.slice(-19, 20)
      })
      channel.on('messages', ({ messages }) => {
        this.messages = messages.slice(-19, 20)
      })
      channel.join()
      this.channel = channel
    },
    disconnectSocket() {
      this.socket?.disconnect()
      this.socket = null
      this.channel = null
      this.joined = false
    },
  },
})
